// extracted by mini-css-extract-plugin
export var callCard = "_hf-0";
export var callMessageButton = "_hf-1";
export var helpIcon = "_hf-3";
export var helpIconContainer = "_hf-4";
export var verticalDivider = "_hf-2";